import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { ComplexSuggestedItem } from '../../../ui/gzComplexEnumList/types';
import { EasmAssetsInventoryGridWebComponent } from '../component/EasmAssetsInventoryGridWebComponent';
import { EasmFinding, FINDING_TYPE_TO_ICON_MAP } from '../../types';
import { WEB_COMPONENT_EASM_ASSETS_INVENTORY_GRID } from '../../../webcomponents.constants';
import { FindingClassType } from '../../types';

export class EasmAssetsInventoryNameProvider {
  static getExtraFilters(): Array<any> {
    const grid = document.querySelector(
      WEB_COMPONENT_EASM_ASSETS_INVENTORY_GRID
    ) as EasmAssetsInventoryGridWebComponent;

    if (!grid) {
      return [];
    }
    return [grid.getCompanyIdFilterValue()];
  }

  /**
   *
   * @param page
   * @param limit
   * @param searchString
   * @param filters
   * @protected
   */
  static async getRemoteData(
    page: number,
    limit: number,
    searchString: string = '',
    filters: Array<any> = []
  ): Promise<Array<EasmFinding>> {
    const result = await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'EASMFindings',
      method: 'getAvailableFindings',
      payload: {
        findingClass: FindingClassType.ASSET,
        page,
        limit,
        assetName: searchString,
        companyId: filters[0],
      },
    });
    return result.data;
  }

  /**
   *
   * @param response
   * @protected
   */
  static convertResponse(response: Array<EasmFinding>): ComplexSuggestedItem[] {
    return response.map((item: EasmFinding) => {
      return {
        label: item.name,
        value: item.name,
        type: item.type,
      };
    });
  }

  static getTypeToIconMapping(): Map<number, string> {
    return FINDING_TYPE_TO_ICON_MAP;
  }
}
